class HelpStaticListSpecialPerson {
  title = ''
  content = ''
  id = ''

  static initHelp(): Array<HelpStaticListSpecialPerson> {
    // 报名
    const resultList = new Array<HelpStaticListSpecialPerson>()
    const signUp = new HelpStaticListSpecialPerson()
    signUp.id = '1'
    signUp.title = '报名时间'
    signUp.content = '暂无'
    resultList.push(signUp)
    const signCondition = new HelpStaticListSpecialPerson()
    signCondition.id = '2'
    signCondition.title = '报名条件'
    signCondition.content = '暂无'
    resultList.push(signCondition)
    const signZhiNan = new HelpStaticListSpecialPerson()
    signZhiNan.id = '3'
    signZhiNan.title = '报名指南'
    signZhiNan.content = '暂无'
    resultList.push(signZhiNan)
    const KSBM = new HelpStaticListSpecialPerson()
    KSBM.id = '4'
    KSBM.title = '考试报名'
    KSBM.content = '暂无'
    resultList.push(KSBM)
    const KSFY = new HelpStaticListSpecialPerson()
    KSFY.id = '5'
    KSFY.title = '考试费用'
    KSFY.content = '暂无'
    resultList.push(KSFY)
    // 备考
    const XXTK = new HelpStaticListSpecialPerson()
    XXTK.id = '6'
    XXTK.title = '学习听课'
    XXTK.content = '暂无'
    resultList.push(XXTK)
    const STLX = new HelpStaticListSpecialPerson()
    STLX.id = '7'
    STLX.title = '试题练习'
    STLX.content = '暂无'
    resultList.push(STLX)
    const MNKS = new HelpStaticListSpecialPerson()
    MNKS.id = '8'
    MNKS.title = '模拟学习'
    MNKS.content = '暂无'
    resultList.push(MNKS)
    const MRYL = new HelpStaticListSpecialPerson()
    MRYL.id = '9'
    MRYL.title = '每日一练'
    MRYL.content = '暂无'
    resultList.push(MRYL)
    const CTCD = new HelpStaticListSpecialPerson()
    CTCD.id = '10'
    CTCD.title = '错题重答'
    CTCD.content = '暂无'
    resultList.push(CTCD)
    // 考试时间
    const KSSJ = new HelpStaticListSpecialPerson()
    KSSJ.id = '11'
    KSSJ.title = '考试时间'
    KSSJ.content = '暂无'
    resultList.push(KSSJ)
    const ZKZDY = new HelpStaticListSpecialPerson()
    ZKZDY.id = '12'
    ZKZDY.title = '准考证打印'
    ZKZDY.content = '暂无'
    resultList.push(ZKZDY)
    const ZXKS = new HelpStaticListSpecialPerson()
    ZXKS.id = '13'
    ZXKS.title = '在线考试'
    ZXKS.content = '暂无'
    resultList.push(ZXKS)
    // 查分
    const CXSJ = new HelpStaticListSpecialPerson()
    CXSJ.id = '14'
    CXSJ.title = '查分时间'
    CXSJ.content = '暂无'
    resultList.push(CXSJ)
    const CFRK = new HelpStaticListSpecialPerson()
    CFRK.id = '15'
    CFRK.title = '查分入口'
    CFRK.content = '暂无'
    resultList.push(CFRK)
    const HGBZ = new HelpStaticListSpecialPerson()
    HGBZ.id = '16'
    HGBZ.title = '合格标准'
    HGBZ.content = '暂无'
    resultList.push(HGBZ)
    const LZSJ = new HelpStaticListSpecialPerson()
    LZSJ.id = '17'
    LZSJ.title = '领证时间'
    LZSJ.content = '暂无'
    resultList.push(LZSJ)
    const ZSLQ = new HelpStaticListSpecialPerson()
    ZSLQ.id = '18'
    ZSLQ.title = '证书领取'
    ZSLQ.content = '暂无'
    resultList.push(ZSLQ)
    return resultList
  }
}

export default HelpStaticListSpecialPerson
